var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaizoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 17,
    viewBox: "0 0 79 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3205 1.97986H0.668762V5.45461H4.52562V15.9587H8.46369V5.45461H12.3205V1.97986Z",
    fill: "#393939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1747 5.17503L20.789 6.01376C19.8958 5.27488 18.7388 4.85551 17.4396 4.85551C14.0902 4.85551 11.6949 7.23192 11.6949 10.5669C11.6949 13.9218 14.0902 16.3182 17.4396 16.3182C18.7185 16.3182 19.8552 15.9188 20.7484 15.1999L21.0732 15.9587H23.9963V5.17503H21.1747ZM17.9471 13.0431C16.5261 13.0431 15.4909 11.9847 15.4909 10.5669C15.4909 9.16899 16.5261 8.13056 17.9471 8.13056C19.368 8.13056 20.4033 9.16899 20.4033 10.5669C20.4033 11.9847 19.368 13.0431 17.9471 13.0431Z",
    fill: "#393939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3994 3.83705H30.1344V0.681824H26.3994V3.83705ZM26.3791 15.9587H30.1547V5.17503H26.3791V15.9587Z",
    fill: "#393939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0308 12.6637L41.1718 5.7941V5.17503H32.1184V8.47005H35.9549L31.753 15.4195V15.9587H41.2124V12.6637H37.0308Z",
    fill: "#393939"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3337 16.3182C51.9064 16.3182 54.4844 13.9018 54.4844 10.5669C54.4844 7.23192 51.9064 4.83554 48.3337 4.83554C44.761 4.83554 42.2033 7.23192 42.2033 10.5669C42.2033 13.9018 44.761 16.3182 48.3337 16.3182ZM48.3337 12.9832C46.9736 12.9832 45.979 12.0047 45.979 10.5869C45.979 9.14902 46.9736 8.1705 48.3337 8.1705C49.714 8.1705 50.7087 9.16899 50.7087 10.5869C50.7087 12.0047 49.714 12.9832 48.3337 12.9832Z",
    fill: "#393939"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0912 15.9587H59.7653V12.5239H56.0912V15.9587Z",
    fill: "#393939"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0222 3.83705H65.7573V0.681824H62.0222V3.83705ZM62.0019 15.9587H65.7776V5.17503H62.0019V15.9587Z",
    fill: "#393939"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7648 4.87548C73.3438 4.87548 72.1259 5.3947 71.3139 6.29334L70.8064 5.17503H68.1472V15.9587H71.9229V10.2074C71.9229 8.82951 72.5927 8.03071 73.7701 8.03071C74.7242 8.03071 75.2114 8.64978 75.2114 9.90788V15.9587H78.987V9.38866C78.987 6.6528 77.3022 4.87548 74.7648 4.87548Z",
    fill: "#393939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaizoin);
export default __webpack_public_path__ + "static/media/taizoin.929a94aca9d08560e5e60b1bd9307427.svg";
export { ForwardRef as ReactComponent };